import { AccountingsKpiGateway } from "../gateway/AccountingsKpiGateway/AccountingsKpiGateway";

/**
 * Os KPIs do mês da tela Administrativo, buscados UMA vez por abertura.
 *
 * Dois componentes leem o mesmo payload: a tela pai, que pinta os cards, e a lista de clientes,
 * que pinta a contagem das abas de filtro rápido. O filho é montado pelo `ui-view` e não recebe
 * bindings do pai, então não há como passar o resultado para baixo — sem a memoização os dois
 * disparariam a mesma requisição, e ela agora carrega uma agregação sobre a collection inteira
 * de contabilidades.
 *
 * Guarda a PROMESSA, não o resultado: quem chega no meio do voo espera a mesma resposta em vez
 * de abrir uma segunda. A chave é o mês, que é o que muda a resposta.
 */
export class GetAccountingsKpiUsecase {
    static _emVoo = new Map();

    constructor() {
        this.AccountingsKpiGateway = new AccountingsKpiGateway();
    }

    async execute({ year, month } = {}) {
        const payload = this.sanitizeInput({ year, month });
        if (!payload.year || !payload.month) return null;

        const chave = `${payload.year}-${payload.month}`;
        if (!GetAccountingsKpiUsecase._emVoo.has(chave)) {
            const promessa = this.AccountingsKpiGateway.getByYearAndMonth(
                payload
            ).catch((error) => {
                // Falha não fica memorizada: a próxima abertura da tela tem que poder tentar
                // de novo.
                GetAccountingsKpiUsecase._emVoo.delete(chave);
                throw error;
            });
            GetAccountingsKpiUsecase._emVoo.set(chave, promessa);
        }

        return await GetAccountingsKpiUsecase._emVoo.get(chave);
    }

    /** Mês corrente — o que a tela sempre pede. */
    async executeCurrentMonth() {
        const date = new Date();
        return await this.execute({
            year: date.getFullYear().toString(),
            month: (date.getMonth() + 1).toString()
        });
    }

    sanitizeInput({ year = "", month = "" } = {}) {
        return {
            year: String(year || "").trim(),
            month: String(month || "").trim()
        };
    }

    static clearCache() {
        GetAccountingsKpiUsecase._emVoo.clear();
    }
}
